import React from "react";
import "./css/playerBodyFallback.css";

function PlayerBodyFallback() {
  return (
    <div className="player-body-fall">
      <h1>Select a Playlist to view and play songs from playlist.</h1>
    </div>
  );
}

export default PlayerBodyFallback;
